import { Button, CardActions, CardContent, FormHelperText, Grid, IconButton, InputAdornment, TextField, Typography } from '@material-ui/core'
import React, { useEffect, useState } from 'react'
import { createStyles, makeStyles } from '@material-ui/core/styles';
import { Card } from '@material-ui/core';
import { mdiEyeOffOutline, mdiEyeOutline } from '@mdi/js';
import Icon from '@mdi/react';
import { useForm } from 'react-hook-form';
import handleError from '../../utils/handleError';
import usersRepository from 'client-sdk/src/Repository/users-repository';
import handleNotfication from '../../utils/handleNotfication';
import history from '../../utils/history';

const useStyles = makeStyles(theme =>
    createStyles({
        header: {
            width: "100%",
            textAlign: "center",
            padding: "25px 0",
            fontSize: "20px",
            fontWeight: "bolder"
        },
        card: {
            width: '50%',
            boxShadow: 'none !important',
            border: '1px solid lightgray',
            marginBottom: '8px',
        },
        adminCard: {
            width: '50%',
            boxShadow: 'none !important',
            marginBottom: '8px',
            borderRadius: '10px',
            backgroundColor: "#2F4858",
            color: "#fff",
            justifySelf: "end",
            borderTopRightRadius: "0px",
        },
        userCard: {
            width: '100%',
            boxShadow: 'none !important',
            border: '1px solid lightgray',
            marginBottom: '8px',
            borderRadius: '10px',
            backgroundColor: "#fff",
            borderTopLeftRadius: "0px",
        },
        container: {
            display: "grid",
            width: "100%",
        },
        userName: {
            margin: "5px",
            fontWeight: 700
        },
        adminUserName: {
            margin: "5px",
            fontWeight: 700,
            textAlign: "right"
        },
        adminDate: {
            textAlign: "right"
        }
    })
);

const ProfileCard = ({
    data,
}) => {
    const classes = useStyles();
    const [hidePass, setHidePass] = useState<Boolean>(true);
    const [hideConf, setHideConf] = useState<Boolean>(true);
    const { handleSubmit, register, errors, reset, getValues } = useForm()

    useEffect(() => {
        if (data) {
            reset({
                userName: data.name,
                email: data.emailAddress,
                phoneNumber: data.phoneNumber
            })
        }
    }, [data])

    const onSubmit = async (form: any) => {
        const body = {
            emailAddress: data.email,
            id: data.id,
            name: data.name,
            phoneNumber: data.phoneNumber,
            role: data.role,
            password: form.password
        }
        try {
            const response = await usersRepository.updateProfile({ payload: { body } })
            handleNotfication("رمز عبور با موفقیت ویرایش شد", "success")
            reset({
                userName: data.name,
                email: data.emailAddress,
                phoneNumber: data.phoneNumber,
                password: "",
                confirm: ""
            })
        } catch (error) {
            handleError(error)
        }
    }


    return (
        <form onSubmit={handleSubmit(onSubmit)}>
            <Card className={classes.userCard}>
                <Typography className={classes.header}>
                    حساب کاربری
                </Typography>
                <CardContent style={{ padding: '16px' }}>
                    <Grid container spacing={2}>
                        <Grid item lg={4}>
                            <TextField
                                inputRef={register({
                                    required: true
                                })}
                                InputLabelProps={{
                                    shrink: !!data?.name || !!getValues().name
                                }}
                                error={errors.hasOwnProperty('userName')}
                                name="userName"
                                label="نام‌کاربری"
                                fullWidth
                                variant='outlined'
                                disabled
                            />
                            <FormHelperText error focused>
                                {errors.userName?.type == "required" && 'نام کاربری الزامی میباشد'}
                            </FormHelperText>
                        </Grid>
                        <Grid item lg={4}>
                            <TextField
                                inputRef={register({
                                    required: true
                                })}
                                InputLabelProps={{
                                    shrink: !!data?.phoneNumber || !!getValues().phoneNumber
                                }}
                                error={errors.hasOwnProperty('phoneNumber')}
                                name="phoneNumber"
                                label="شماره‌تماس"
                                fullWidth
                                variant='outlined'
                                disabled
                            />
                            <FormHelperText error focused>
                                {errors.phoneNumber?.type == "required" && 'شماره تماس الزامی میباشد'}
                            </FormHelperText>
                        </Grid>
                        <Grid item lg={4}>
                            <TextField
                                inputRef={register({
                                    required: true
                                })}
                                InputLabelProps={{
                                    shrink: !!data?.emailAddress || !!getValues().email
                                }}
                                error={errors.hasOwnProperty('email')}
                                name="email"
                                label="ایمیل"
                                fullWidth
                                variant='outlined'
                                type="email"
                                disabled
                            />
                            <FormHelperText error focused>
                                {errors.email?.type == "required" && 'ایمیل الزامی میباشد'}
                            </FormHelperText>
                        </Grid>
                        <Grid item lg={4}>
                            <TextField
                                inputRef={register({
                                    required: true,
                                    minLength: 8
                                })}
                                error={errors.hasOwnProperty('password')}
                                name="password"
                                label="رمزعبور"
                                fullWidth
                                variant='outlined'
                                type={hidePass ? 'password' : 'text'}
                                InputProps={{
                                    endAdornment: (
                                        <InputAdornment position="end">
                                            <IconButton onClick={() => setHidePass(!hidePass)}>
                                                <Icon
                                                    path={hidePass ? mdiEyeOffOutline : mdiEyeOutline}
                                                    size={1}
                                                    className={classes.icon}
                                                />
                                            </IconButton>
                                        </InputAdornment>
                                    ),
                                }}
                            />
                            <FormHelperText error focused>
                                {errors.password?.type == "required" && 'رمزعبور الزامی میباشد'}
                            </FormHelperText>
                            <FormHelperText error focused>
                                {errors.password?.type == "minLength" && 'رمز عبور نباید کمتر از ۸ کاراکتر باشد'}
                            </FormHelperText>
                        </Grid>
                        <Grid item lg={4}>
                            <TextField
                                inputRef={register({
                                    required: true,
                                    minLength: 8
                                })}
                                error={errors.hasOwnProperty('confirm') || getValues().password != getValues().confirm}
                                name="confirm"
                                label="تکرار رمزعبور"
                                fullWidth
                                variant='outlined'
                                type={hideConf ? 'password' : 'text'}
                                InputProps={{
                                    endAdornment: (
                                        <InputAdornment position="end">
                                            <IconButton onClick={() => setHideConf(!hideConf)}>
                                                <Icon
                                                    path={hideConf ? mdiEyeOffOutline : mdiEyeOutline}
                                                    size={1}
                                                    className={classes.icon}
                                                />
                                            </IconButton>
                                        </InputAdornment>
                                    ),
                                }}
                            />
                            <FormHelperText error focused>
                                {errors.confirm?.type == "required" && 'تکرار رمزعبور الزامی میباشد'}
                            </FormHelperText>
                            <FormHelperText error focused>
                                {errors.confirm?.type == "minLength" && 'تکرار رمز عبور نباید کمتر از ۸ کاراکتر باشد'}
                            </FormHelperText>
                            <FormHelperText error focused>
                                {getValues().password != getValues().confirm && 'تکرار رمز عبور اشتباه است'}
                            </FormHelperText>
                        </Grid>
                    </Grid>
                </CardContent>
                <CardActions>
                    <Grid container spacing={3}>
                        <Grid item lg={7}>
                            <Button
                                size='large'
                                type='submit'
                                variant='contained'
                                color='secondary'
                                fullWidth
                            >
                                ویرایش اطلاعات
                            </Button>
                        </Grid>
                        <Grid item lg={5}>
                            <Button
                                size='large'
                                variant='contained'
                                fullWidth
                                onClick={() => history.goBack()}
                            >
                                انصراف
                            </Button>
                        </Grid>
                    </Grid>
                </CardActions>
            </Card >
        </form>
    )
}

export default ProfileCard;
